import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from '@shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { devtoolsModules } from './store/devtools';
import { LogoutComponent } from './loggedout/logout/logout.component';
import { PaymentComponent } from './loggedout/payment/payment.component';
import { initAppConfig } from './store/initializer';
import { TranslateModule } from '@ngx-translate/core';
import { localeLoader, LocaleService, translatesLoader } from '@shared/translations';
import { effects, reducers } from '@rootstore/index';
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressRouterModule } from 'ngx-progressbar/router';
import { GuardsCheckEnd, GuardsCheckStart, NavigationEnd } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import { DatalistsService } from '@shared/services';

import localePl from '@angular/common/locales/pl';
registerLocaleData(localePl, 'pl');

import localeEn from '@angular/common/locales/en';
registerLocaleData(localeEn, 'en');

@NgModule({
  declarations: [
    AppComponent,
    LogoutComponent,
    PaymentComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule.forRoot(),
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot(effects),
    TranslateModule.forRoot(),
    devtoolsModules,
    NgProgressModule.withConfig({
      color: '#49605f',
      spinnerPosition: 'left',
      spinner: true,
      meteor: true
    }),
    NgProgressRouterModule.withConfig({
      startEvents: [GuardsCheckStart],
      completeEvents: [NavigationEnd],
      delay: 100,
      id: 'router-progressbar'
    })
  ],
  providers: [
    initAppConfig,
    translatesLoader,
    localeLoader,
    LocaleService,
    DatalistsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
